export default __webpack_public_path__ + "assets/sounds/98c23bef4b01ecb80e9506c9da1d0175.mp3";